import React, { useState } from 'react';
import { minerals } from '../minerals.js';
import '../styles/LandingPage.css';

export default function LandingPage({ onMineralSelect }) {
  const [searchQuery, setSearchQuery] = useState('');

  const filteredMinerals = minerals.filter(mineral =>
    mineral.name.toLowerCase().includes(searchQuery.toLowerCase())
  );

  return (
    <div className="landing-page">
      <h1 className="landing-title">Select a Mineral</h1>
      <div className="search-bar">
        <input
          type="text"
          placeholder="Search minerals..."
          value={searchQuery}
          onChange={(e) => setSearchQuery(e.target.value)}
        />
      </div>
      <div className="mineral-grid">
        {filteredMinerals.map(mineral => (
          <div
            key={mineral.name}
            className="mineral-card"
            onClick={() => onMineralSelect(mineral.name)}
          >
            <div className="mineral-symbol">{mineral.symbol}</div>
            <div className="mineral-number">{mineral.atomic_number || ''}</div>
            <div className="mineral-name">{mineral.name}</div>
          </div>
        ))}
      </div>
    </div>
  );
}
